
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/zoomMode/components/SectionsDropZoneContainer/SectionsDropZoneContainer.scss.css.virtualfile';
        module.exports = {"container":"_container_f4pcx_1"};